import { nextTick } from 'vue'
import goTo from 'vuetify/lib/services/goto'
import moment from 'moment'
import { utils, createStorage } from '@/api'

moment.locale('nl')


export function scrollToTop() {
  window.scrollTo(0, 0)
}

export function scrollToFirstError() {
  nextTick(() => {
    let el = document.querySelector(".v-input.error--text:first-of-type")
    if (el) {
      let dialog = document.getElementsByClassName('v-dialog--active')[0]
      if (dialog) {
        goTo(el, { container: dialog })
      } else {
        goTo(el)
      }
    }
  })
}

export const readFileAsDataUrl = utils.readFileAsDataUrl

export function formatDate(date, format = 'L') {
  return !utils.isEmpty(date) ? (Number.isInteger(date) ? moment.unix(date).format(format) : moment(date).format(format)) : ''
}

export function formatDateTime(date, format = 'lll') {
  return formatDate(date, format)
}

export function formatCurrency(amount) {
  return !utils.isEmpty(amount) ? '€ ' + utils.numberFormat(amount, 2, '.', ',') : ''
}

export function formatPercentage(percentage, decimals) {
  if (decimals) {
    return !utils.isEmpty(percentage) ? utils.numberFormat(percentage, decimals, ',', '.') + '%' : ''
  }
  return !utils.isEmpty(percentage) ? utils.trim(utils.rtrim(utils.numberFormat(percentage, 9, ',', '.'), '0'), ',') + '%' : ''
}

export function formatNumber(number, decimals) {
  if (decimals) {
    return !utils.isEmpty(number) ? utils.numberFormat(number, decimals, ',', '.') : ''
  }
  return !utils.isEmpty(number) ? utils.trim(utils.rtrim(utils.numberFormat(number, 9, ',', '.'), '0'), ',') : ''
}

export const numberFormat = utils.numberFormat
export const trim = utils.trim
export const parseJson = utils.parseJson

export function formatText(text) {
  return text ? String(text).replace(/\r?\n/g, '<br>') : ''
}

export const store = createStorage(sessionStorage)

